import React from 'react'

import { LinkToShipment } from './LinkToShipment'

interface TrackingCellProps {
  urlFragment: string
  value: string
}

export const TrackingCell: React.VFC<TrackingCellProps> = ({ urlFragment, value }) => (
  <LinkToShipment orderId={value} urlFragment={urlFragment} />
)
